import { createSelector } from "reselect";

import type { MainNavigationStore } from "../stores/types";

export const selectIsGroupExpanded = createSelector(
  (state: MainNavigationStore) => state.expandedGroupIds,
  (_: MainNavigationStore, groupId: string) => groupId,
  (expandedGroupIds, groupId): boolean => {
    return expandedGroupIds.has(groupId);
  }
);
